var Model = require('../Model');
var model = Object.create(Model);

function trimmed(value) {
  if (value === undefined || value === null) return '';
  return String(value).trim();
}

function normalizedVmac(value) {
  return trimmed(value).replace(/[:-]/g, '').toLowerCase();
}

function normalizedNumber(value) {
  if (value === undefined || value === null || String(value).trim() === '') return null;
  var number = Number(value);
  return Number.isFinite(number) ? number : value;
}

function normalizedEnabled(value) {
  if (value === true || value === 1) return 1;
  var text = String(value == null ? '' : value).trim().toLowerCase();
  return ['1', 'true', 'yes', 'on'].indexOf(text) !== -1 ? 1 : 0;
}

model.name = 'BACnet/SC Hub';
model['@class'] = 'BacnetScConnection';
model.url = 'bacnetscconnection';
model.fields = {
  enabled: {
    type: 'switch',
    default: 0,
    normalize: normalizedEnabled,
  },
  name: {
    type: 'text',
    default: '',
    normalize: trimmed,
  },
  localVmac: {
    type: 'text',
    default: '',
    normalize: normalizedVmac,
  },
  deviceUuid: {
    type: 'text',
    default: '',
    normalize: trimmed,
  },
  primaryHubUrl: {
    type: 'text',
    default: '',
    normalize: trimmed,
  },
  failoverHubUrl: {
    type: 'text',
    default: '',
    normalize: trimmed,
  },
  certPath: {
    type: 'text',
    default: '',
    normalize: trimmed,
  },
  keyPath: {
    type: 'text',
    default: '',
    normalize: trimmed,
  },
  caPath: {
    type: 'text',
    default: '',
    normalize: trimmed,
  },
  pfxPath: {
    type: 'text',
    default: '',
    normalize: trimmed,
  },
  passphraseEnv: {
    type: 'text',
    default: '',
    normalize: trimmed,
  },
  encryptedTlsFiles: {
    default: '',
    normalize: trimmed,
  },
  tlsFilesFingerprint: {
    default: '',
    normalize: trimmed,
  },
  servername: {
    type: 'text',
    default: '',
    normalize: trimmed,
  },
  tlsMinVersion: {
    type: 'select',
    default: 'TLSv1.3',
    normalize: trimmed,
  },
  tlsMaxVersion: {
    type: 'select',
    default: '',
    normalize: trimmed,
  },
  connectionWaitTimeout: {
    type: 'text',
    default: 10000,
    normalize: normalizedNumber,
  },
  webSocketWaitTimeout: {
    type: 'text',
    default: 30000,
    normalize: normalizedNumber,
  },
  heartbeatInterval: {
    type: 'text',
    default: 30000,
    normalize: normalizedNumber,
  },
  reconnectMin: {
    type: 'text',
    default: 1000,
    normalize: normalizedNumber,
  },
  reconnectMax: {
    type: 'text',
    default: 30000,
    normalize: normalizedNumber,
  },
  managed: {
    default: 0,
    normalize: normalizedEnabled,
  },
  managedKey: {
    default: '',
    normalize: trimmed,
  },
  managedSource: {
    default: '',
    normalize: trimmed,
  },
  managedReady: {
    default: 0,
    normalize: normalizedEnabled,
  },
  managedRequestedEnabled: {
    default: 0,
    normalize: normalizedEnabled,
  },
  managedStatus: {
    default: '',
    normalize: trimmed,
  },
  managedConfigHash: {
    default: '',
    normalize: trimmed,
  },
  managedUpdatedAt: {
    default: '',
    normalize: trimmed,
  },
  managedDetachedAt: {
    default: '',
    normalize: trimmed,
  },
};

module.exports = model;
